import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-input-auto-complete',
  templateUrl: './input-auto-complete.component.html',
  styleUrls: ['./input-auto-complete.component.scss']
})
export class InputAutoCompleteComponent implements OnChanges {
  @ViewChild('ele') ele: ElementRef = {} as ElementRef;
  @Input() displayValueKey: string = ''
  @Input() displayFirstLine: string
  @Input() displaySecondLine: string
  @Input() enableAddressAllfacilities: boolean = false
  @Input() type: string = 'text'
  @Input() labelValue: string = ''
  @Input() required: boolean = false
  @Input() isReadOnly: boolean = false
  @Input() placeholder: string = ''
  @Input() validateField: boolean = false
  @Input() InvalidMessage: string = ''
  @Input() containerClass: string = 'mb-3 me-3'
  @Input() value: string = ''
  @Input() enableClear: boolean = false
  @Input() isFormValid: boolean | null = true
  control = new FormControl('');
  @Input() dropDownValue: string[] = [];
  @Output() onSelected = new EventEmitter()
  @Output() onClear = new EventEmitter()
  @Output() onKeyUpChanges = new EventEmitter()
  @Output() onInputChanges = new EventEmitter()
  isOpen = false
  dropDownValue1: string[] = [];
  @Input() id: string = ''
  @Input() maxlen:any=200;
  @Input() showTooltip: boolean = false;
  contentwidth = 0
  centered = false;
  disabled = false;
  unbounded = false;
  radius: number = 10;
  color: string = 'primary';
  toolTipText: any;
  optionToolTipText: any;
  tooTipText='';

  toggle(event: any = null) {
    if (event) {
      (event.keyCode === 8 || event.keyCode === 46) && !this.isOpen ? this.onSelected.emit(this.ele.nativeElement.value) : ''
    }
    this.contentwidth = this.ele.nativeElement.clientWidth
    !this.isReadOnly ? this.dropDownValue1 = this._filter(this.ele.nativeElement.value) : ''
  }

  ngOnInit(): void {
    this.control.patchValue(this.value)
  }

  enableToolTip(e) {
    const text = e.scrollWidth > e.clientWidth ? e.textContent : '';
    this.toolTipText = text;
  }
  private _filter(value: string) {
    this.onKeyUpChanges.emit(value);
    if (value?.length && this.dropDownValue?.length) {
      const filterValue = this._normalizeValue(value);
      if (!this.displayValueKey?.trim()) {
        return this.dropDownValue.filter((i) =>
          this._normalizeValue(i?.toString() ?? '').includes(filterValue)
        );
      }
      return this.dropDownValue.filter((i) =>
        this._normalizeValue(i?.[this.displayValueKey]?.toString() ?? '').includes(filterValue)
      );
    }
    return this.dropDownValue;
  }

  /** Compare search vs options ignoring case and spaces ("Large I" matches "Large Intestine"). */
  private _normalizeValue(value: string): string {
    return (value ?? '').toLowerCase().replace(/\s+/g, '');
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.control.patchValue(this.value)
  }

  onInput(event: Event,type) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > this.maxlen && type === 'number') {
      this.onInputChanges.emit({isValidNumber: inputElement.value.length === this.maxlen ? true:false, value: inputElement.value});
      inputElement.value = inputElement.value.slice(0, this.maxlen); 
    }
  }

  onFocus() {
    this.isOpen = true;
  }
  
  focusedIndex = -1;

  onKeyDown(event: KeyboardEvent) {
    if (this.isOpen) {
      if (event.key === 'ArrowDown') {
        this.focusedIndex = (this.focusedIndex + 1) % this.dropDownValue1.length;
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        this.focusedIndex = (this.focusedIndex - 1 + this.dropDownValue1.length) % this.dropDownValue1.length;
        event.preventDefault();
      } else if (event.key === 'Enter') {
        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropDownValue1.length) {
          this.selectItem(!this.displayValueKey?.trim()?this.dropDownValue1[this.focusedIndex]:this.dropDownValue1[this.focusedIndex][this.displayValueKey]);
        }
      } else if (event.key === 'Escape') {
        this.isOpen = false;
      }
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.isOpen = false;
    }
  }


  selectItem(value: any) {
    if(!this.displayValueKey.trim()){
      this.onKeyUpChanges.emit(value)
      this.control.patchValue(value);
      this.onSelected.emit(value);
      this.isOpen = false;
    }else{
      this.onKeyUpChanges.emit(value[this.displayValueKey])
      this.control.patchValue(value[this.displayValueKey]);
      this.onSelected.emit(value);
      this.isOpen = false;
    }
    
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.ele.nativeElement.focus();
  }

  onBackdropClick() {
    this.isOpen = false;
    this.onSelected.emit(this.ele.nativeElement.value);
  }

  clearValue(){
    this.onKeyUpChanges.emit('')
    this.control.patchValue('');
    this.onSelected.emit('');
    this.onClear.emit({isClear :true});
  }

  toolTipshow(element: any) {
    const isOverflowing =
      element.scrollWidth > element.clientWidth ||
      element.scrollHeight > element.clientHeight;

    const text = element.value?.trim() || '';

    this.tooTipText = isOverflowing ? text : '';
  }

}

